// 製播會 / 控師的唯讀頁（/crew/<連結碼>）和產生連結那一段的文字。全站只在這裡寫一次。
// 頁面固定標示的那一句一字不改（CREW_NOTICE）；不做任何工程或速度的警告（機關照設定的時間動，這只是預覽）。

/** 頁面上固定標示的那一句：一字不改 */
export const CREW_NOTICE = '預覽參考，實際動作以現場機關為準';

export const CREW_TEXT = {
  notice: CREW_NOTICE,
  readOnly: '唯讀',
  // 產生連結
  panelTitle: '製播會 / 控師唯讀連結',
  panelHint: '傳給製播會或控師：不用登入就能看舞台、歌單、全場機關動作和機關總表，也看得到哪些 cue 已經導演確認。什麼都不能改、不能留言。',
  nameLabel: '連結名稱（只有團隊看得到）',
  namePlaceholder: '例：製播會、控台',
  expiryLabel: '有效期',
  mediaLabel: '放影片和音樂',
  mediaHint: '不勾：LED 不放真實畫面，只看機關動作（建議）。勾選：不用登入就看得到畫面、聽得到音樂，能播不能下載，也沒有浮水印。產生後不能改，要放就另開一條。',
  mediaOn: '有放影片和音樂',
  mediaOff: '不放影片和音樂',
  noMediaStatus: '這條連結不放影片和音樂',
  createButton: '+ 產生唯讀連結',
  created: '已產生唯讀連結（已複製）',
  createFailed: '產生失敗：',
  none: '還沒有唯讀連結',
  stopTitle: '停用這個唯讀連結？',
  stopMessage: '已經傳出去的這個連結會馬上打不開。要再給人看就重新產生一條。',
  stopConfirm: '停用',
  stopped: '已停用連結',
  stopFailed: '停用失敗：',
  // 頁面
  loading: '載入中…',
  invalidTitle: '連結無效',
  invalidHint: '這條連結可能已經被停用或過期，請跟傳給你的人要新的。',
  songs: '歌曲',
  allSongs: '全部歌曲',
  noContent: '這個專案沒有可預覽的內容',
  download: '下載機關總表',
  downloading: '整理中…',
  downloaded: '已下載機關總表（用 Excel 打開）',
  downloadFailed: '下載機關總表失敗：',
  noMechanisms: '這個專案還沒有機關，沒有機關總表可以下載',
  motionTitle: '全場機關動作',
  motionHint: '每個機關每一段怎麼動：方向、距離、幾秒開始、走幾秒。',
  motionEmpty: '這首歌的機關沒有需要動的地方',
  noCues: '這首歌還沒有 cue',
  colTime: '開始',
  colCue: 'Cue',
  colMech: '機關',
  colMove: '動作（方向、距離、開始、走幾秒）',
  colEnd: '到位',
  colRange: '位置',
  timeline: '機關時間軸',
  confirmedSummary: (done: number, total: number) => `導演已確認 ${done} / ${total}`,
  allConfirmed: '這首歌的 cue 都已經導演確認',
  somePending: (n: number) => `還有 ${n} 個 cue 待確認，可能還會調整`,
  legendConfirmed: '已確認',
  legendPending: '待確認',
  legendReturned: '改過，已退回待確認',
} as const;
